import { render } from "./sidebarView.vue?vue&type=template&id=104fb3ec"
import script from "./sidebarView.vue?vue&type=script&lang=js"
export * from "./sidebarView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__